import { useEffect, useMemo, useState } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { HeatmapChart } from "echarts/charts";
import * as S from "./HeatmapChart.style";

interface HeatmapChartProps {
  label?: string;
  data?: any;
  onClickHeatMap?: (sensorName: string | null) => void;
  type?: string;
}

export const HeatmapCharts = ({
  label,
  data,
  onClickHeatMap,
  type,
}: HeatmapChartProps) => {
  const [series, setSeries] = useState<any>([]);
  const sensor = [""];
  const options = useMemo(
    () => ({
      tooltip: {
        position: "bottom",
        formatter: function (params: any) {
          return params.name; // Only show the time slot
        },
      },
      grid: {
        show: true,
        width: "calc(100% - 40px)",
        height: "20px",
        top: "0",
        left: "0",
        backgroundColor: "#F2F2F2",
      },
      xAxis: {
        show: true,
        type: "category",
        data: data.timeslots,
        splitArea: {
          show: true,
        },
      },
      yAxis: {
        show: false,
        type: "category",
        data: sensor,
      },
      visualMap: {
        show: false,
        min: 0,
        max: 5,
        orient: "horizontal",
        left: "center",
        top: "top",
        splitNumber: 3, // 구간 수
        color: ["#FF4D58", "#FFBC11", "#00C572"], // 빨강, 노랑, 초록 순으로 색상 지정
        pieces: [
          { min: 1, max: 2, color: "#00C572" },
          { min: 3, max: 4, color: "#FFBC11" },
          { min: 5, max: 5, color: "#FF4D58" },
          { min: -200 || "-", max: 0.9, color: "#F2F2F2" },
        ],
      },

      series: [
        {
          type: "heatmap",
          data: series.map(function (item: any) {
            return [item[1], item[0], item[2] || "-"];
          }),
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.2)",
            },
          },
        },
      ],
      onClick: function () {
        return console.log("click");
      },
    }),
    [series, data.timeSlots]
  );

  useEffect(() => {
    const tempSeries = data?.counts?.map((item: any, idx: number) => {
      return [0, idx, item];
    });
    setSeries(tempSeries);
  }, [data]);

  echarts.use([HeatmapChart]);

  return (
    <S.HeatmapChartBox
      onClick={() => onClickHeatMap?.(data.steSensorCode || null)}
    >
      {label && <S.HeatmapLabel>{label}</S.HeatmapLabel>}

      <ReactECharts
        echarts={echarts}
        option={options}
        opts={{ renderer: "svg" }}
        style={{ width: "100%", height: "100%" }}
      />
    </S.HeatmapChartBox>
  );
};
